import React, { Component } from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import Notifications from 'react-notify-toast';
import MaskedInput from 'react-text-mask';

// Components
import Media from './Media';
import logo from '../../../img/logo.png';

const StepIn = observer(class StepIn extends Component {
  constructor() {
    super();
    this.editSession = this.editSession.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    this.state = {
      sessionInput: null
    }

    if(this.props.accessCode) {
      this.props.store.StepInStore.lookupSession(this.props.accessCode);
    }
  }

  editSession(input) {
    this.setState({
      sessionInput: input
    })
  }

  submitForm(e) {
    e.preventDefault();
    this.props.store.StepInStore.lookupSession(this.state.sessionInput);
  }

  render() {
    const { translation } = this.props;
    const { StepInStore } = this.props.store;
    const { tracks } = StepInStore;

    const media = this.props.store.StepInStore.tracks.map(
      (media, i) => {
        return <Media key={i} media={media} />
      }
    )

    // const _this = this;
    //
    // setTimeout(function(){
    //   _this.props.store.StepInStore.tracks.map(
    //     (media, i) => {
    //     const track = document.querySelector(`#track-${i}`);
    //     console.log(track);
    //     track.appendChild(media);
    //     return null;
    //   });
    // }, 5000);

    if(this.props.sessionDetail) {
      if(tracks.length === 0) {
        return (
          <div className="cta">
            <Notifications />

            <strong className="cta__copy">{translation.not_started.heading}</strong>

            <span className="cta_subcopy">{translation.not_started.body}</span>
          </div>
        );
      } else {
        return (
          <div className="session-viewer">
            <Notifications />

            <div className="session-viewer__media wrap">
              {media}
            </div>
          </div>
        );
      }
    } else {
      return (
        <div className="drawer__content session-viewer">
          <Notifications />

          <header className="session-viewer__header">
            <img className="session-viewer__logo" src={logo} alt="smarterproctoring" />
          </header>

          {!this.props.accessCode &&
            <form className="filter session-viewer__form" onSubmit={e => this.submitForm(e)}>
              <ul className="fields--inline">
                <li>
                  <label htmlFor="session-id">{translation.access_code}</label>

                  <MaskedInput
                    mask={[/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                    guide={false}
                    type="text"
                    id="session-id"
                    placeholder="123-456-789"
                    required
                    autoFocus
                    onKeyUp={(e) => this.editSession(e.target.value)}
                  />
                </li>
                <li>
                  <button type="submit" className="btn">{translation.connect}</button>
                </li>
              </ul>
            </form>
          }

          <div className="session-viewer__media wrap">
            {media}
          </div>
        </div>
      );
    }
  }
})

export default translate('StepIn')(StepIn);


// WEBPACK FOOTER //
// ./src/app/components/VTC/StepIn.js